module.exports = __webpack_public_path__ + "static/media/fourth.3ef3a495.png";